/* shareable 1200x630 field report, drawn on an offscreen canvas at game over */
import { WORM_TIERS } from "./constants";

export function buildReplayCard(g, bannerImg, best) {
    const total = Math.floor(g.distance) + g.credits * 25;
    const tier = WORM_TIERS[g.tier];
    const c = document.createElement("canvas");
    c.width = 1200;
    c.height = 630;
    const x = c.getContext("2d");

    // wasteland backdrop
    const bg = x.createLinearGradient(0, 0, 0, 630);
    bg.addColorStop(0, "#160408");
    bg.addColorStop(1, "#050505");
    x.fillStyle = bg;
    x.fillRect(0, 0, 1200, 630);
    x.fillStyle = "rgba(153, 0, 26, 0.85)";
    x.beginPath();
    x.arc(522, 92, 62, 0, Math.PI * 2);
    x.fill();
    x.fillStyle = "rgba(153, 0, 26, 0.16)";
    x.beginPath();
    x.arc(522, 92, 96, 0, Math.PI * 2);
    x.fill();

    // official framed key art panel — unified with the arcade banner
    const art = bannerImg;
    if (art) {
      const aw = 510;
      const ah = Math.round(aw * (art.height / art.width));
      const ax = 632;
      const ay = 150;
      x.shadowColor = "rgba(255, 0, 51, 0.45)";
      x.shadowBlur = 30;
      x.imageSmoothingEnabled = false;
      x.drawImage(art, ax, ay, aw, ah);
      x.shadowBlur = 0;
      x.strokeStyle = "rgba(255, 0, 51, 0.8)";
      x.lineWidth = 3;
      x.strokeRect(ax - 6, ay - 6, aw + 12, ah + 12);
    }

    // scanlines
    x.fillStyle = "rgba(0, 0, 0, 0.16)";
    for (let i = 0; i < 630; i += 4) x.fillRect(0, i, 1200, 1);

    // field report text
    x.textAlign = "left";
    x.fillStyle = "#ff0033";
    x.font = "800 24px monospace";
    x.fillText("DOLO'S WASTELAND RUN // FIELD REPORT", 58, 66);
    x.fillStyle = "white";
    x.font = "900 118px monospace";
    x.fillText(String(total).padStart(6, "0"), 54, 190);
    x.fillStyle = "#8c7b75";
    x.font = "800 22px monospace";
    x.fillText(`DISTANCE ${Math.floor(g.distance)}M   CREDITS ${g.credits}   JUMPS ${g.jumpTotal}`, 58, 250);
    x.fillText(`THREAT REACHED — ${tier.name} CLASS   WORM REPELS ${g.repels}`, 58, 284);
    x.fillText(`BEST SIGNAL ${Math.max(best, total)}`, 58, 318);
    x.fillStyle = "#ff0033";
    x.font = "800 20px monospace";
    x.fillText(`${window.location.host}/wasteland-run — OUTRUN THE WORM`, 58, 590);

    // crimson frame
    x.strokeStyle = "#ff0033";
    x.lineWidth = 5;
    x.strokeRect(10, 10, 1180, 610);
    return c.toDataURL("image/png");
}
